module.exports = __webpack_public_path__ + "media/configurations/O-X-X-0a8e9c8b.png";